import { render, staticRenderFns } from "./ViAdmissionHome.vue?vue&type=template&id=3c9f164f&scoped=true"
import script from "./ViAdmissionHome.vue?vue&type=script&lang=js"
export * from "./ViAdmissionHome.vue?vue&type=script&lang=js"
import style0 from "./ViAdmissionHome.vue?vue&type=style&index=0&id=3c9f164f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9f164f",
  null
  
)

export default component.exports